import { FunctionComponent } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserRole } from '@cdaas/api-clients/dist/asset-user-openapi';

import Product from './Product/Product';
import Bundle from './Bundle/Bundle';
import Checkout from './Checkout/Checkout';
import { RootState } from '../../store/reducers';
import { hasUserARequiredRole } from '../../utils';

const Shop: FunctionComponent = () => {
  const authenticated = useSelector((state: RootState) => state.authentication.authenticated);
  const authSeqReady = useSelector((state: RootState) => state.authentication.authSequenceReady);

  return (
    <Switch>
      <Route path={`/shop/product/:id`} component={Product} />
      <Route path={`/shop/bundle/:id`} component={Bundle} />
      {authenticated && hasUserARequiredRole([UserRole.User, UserRole.Orderer]) && <Route path={`/shop/checkout`} component={Checkout} />}
      {authSeqReady && <Redirect to="/home" />}
    </Switch>
  );
};

export default Shop;
